export default "__VITE_ASSET__t0XGTI6V__"